import { useState, useCallback, useEffect } from "react";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import mrpImg from "../../../../assests/Label.png";
import "./ProductVariantDetails.css";
import Button from "@mui/material/Button";
import { Link, useNavigate, useHistory, useParams } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

const ProductVariantDetailsComponent = (props, data) => {
  const { variantId } = useParams();
  const { id } = useParams();
  const navigate = useNavigate();
  
  const handleClick = () => {
    navigate(-1);
  };
  
  const handleCreateMfids = (variantId) => {
    navigate(`/home/configuration/productsvariantdetails/createmfid/${variantId}`);
  };
  
  const handleUpdateMfids = (variant) => {
    navigate(
      `/home/configuration/productsvariantdetails/updatemfid/${variant.id}/${variantId}`,
      { state: { variant } }
    );
  };

  return (
    <div className="product-variant-container">
      <div className="sidebar-wrapper">
        <Sidebar />
      </div>

      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="product-main-content">
          {data && data && (
            <div className="product-details-content">
              <div className="product-header">
                <div className="product-title-section">
                  <img 
                    onClick={handleClick}
                    className="product-back-button"
                    src={leftArrow}
                    alt="Back"
                  />
                  <h3 className="product-name">
                    {props.productData && props.productData.productName}
                  </h3>
                </div>

                <Button
                  className="create-mfid-btn"
                  onClick={() => handleCreateMfids(
                    props.productData && props.productData.variantId
                  )}
                >
                  Create New MFID
                </Button>
              </div>

              <div className="product-info-card">
                <div className="product-image-section">
                  <img
                    className="product-img"
                    alt="Product"
                    src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${
                      props.productData.variantImages &&
                      props.productData.variantImages[0].imageId
                    }`}
                  />
                </div>

                <div className="product-details-section">
                  <div className="detail-row">
                    <span className="detail-label">Variant ID - </span>
                    <span className="detail-value">
                      {props.productData && props.productData.variantId}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Brand Name - </span>
                    <span className="detail-value">
                      {props.productData && props.productData.brandName}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Product Name - </span>
                    <span className="detail-value">
                      {props.productData && props.productData.productName}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">M.R.P - </span>
                    <CurrencyRupeeIcon className="currency-icon" />
                    <span className="detail-value">
                      {props.productData.variantMrp &&
                      props.productData.variantMrp.minMrp !== null &&
                      props.productData.variantMrp.maxMrp !== null
                        ? props.productData.variantMrp.minMrp ===
                          props.productData.variantMrp.maxMrp
                          ? `${props.productData.variantMrp.minMrp}`
                          : `${props.productData.variantMrp.minMrp}-${props.productData.variantMrp.maxMrp}`
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mfid-count-section">
                <p className="mfid-count-text">
                  MFIDs- ({props.mfidCountData.mfIdCount && props.mfidCountData.mfIdCount})
                </p>
              </div>

              <div className="mfid-list-container">
        {props.manufacturerVariantData &&
        props.manufacturerVariantData.length > 0 ? (
          props.manufacturerVariantData.map((item) => (
            <div key={item.id} className="mfid-card">
              <div className="mfid-content-row">
                <div className="mfid-details-section">
                  <div className="mfid-header-section">
                    <span className="mfid-id-text">
                      MFIDs - {item.id}
                    </span>
                    <Button
                      className="edit-mfid-btn"
                      variant="outlined"
                      onClick={() => handleUpdateMfids(item)}
                    >
                      Edit
                    </Button>
                  </div>

                  <div className="mfid-details-grid">
                    <div className="detail-row">
                      <span className="detail-label">Vendor Name - </span>
                      <span className="detail-value">
                        {item.manufacturerName}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Purchase Type - </span>
                      <span className="detail-value">
                        {item.purchaseType ? item.purchaseType : "null"}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">M.R.P - </span>
                      <span className="detail-value">
                        <CurrencyRupeeIcon className="currency-icon" />
                        {item.mrp}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="detail-label">Purchase price - </span>
                      <span className="detail-value">
                        {item.vendorPrice}
                      </span>
                    </div>
                  </div>
                  <div className="selling-price-image-container">
                  <div className="selling-price-overlay">
                    <p className="selling-price-label">Selling Price</p>
                    <span className="selling-price-value">
                      {item.offerPrice}
                    </span>
                  </div>
                </div>
                </div>

               
              </div>
            </div>
          ))
        ) : (
          <div className="empty-mfid-card">
            <div className="empty-mfid-message">
              MFID not found
            </div>
          </div>
        )}
      </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductVariantDetailsComponent;